import { sharedMessages } from '@/lang/shared/messages'

export const sarkMessages = {
  ...sharedMessages,
  confirmPagePayeeInformation: {
    id: 'confirm-page.payee-information',
    defaultMessage: 'Payee information',
    description: 'Title of the payer form on the checkout page',
  },
  confirmPageLegalEntityInformation: {
    id: 'confirm-page.legal-entity-information',
    defaultMessage: 'Legal entity information',
    description: 'Title of the company block on the checkout page',
  },
  confirmPageExistingUser: {
    id: 'confirm-page.existing-user',
    defaultMessage: 'Existing user?',
    description: 'Text before the log-in link on the checkout page',
  },
  confirmPageLogInHere: {
    id: 'confirm-page.log-in-here',
    defaultMessage: 'Log in here',
    description: 'Log-in link on the checkout page',
  },
  confirmPageCreateAccount: {
    id: 'confirm-page.create-account',
    defaultMessage: 'Save this data for further purchases (create account)',
    description: 'Checkbox that creates an account from the checkout form',
  },
}
